import React from "react";

const IArrowShortail = ({
  color = "#252526",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M6.73909 1.47764C6.97005 1.2531 7.33938 1.25815 7.56396 1.48903C7.7885 1.71999 7.78345 2.08932 7.55257 2.3139L2.7321 6.99994L7.55257 11.686C7.78345 11.9106 7.7885 12.2799 7.56396 12.5108C7.33938 12.7417 6.97005 12.7468 6.73909 12.5222L1.4891 7.41807C1.3762 7.30825 1.3125 7.15744 1.3125 6.99994C1.3125 6.84243 1.3762 6.69163 1.4891 6.58181L6.73909 1.47764Z"
        fill={color}
      />
      <path
        d="M12.1042 6.41661C12.4263 6.41661 12.6875 6.67777 12.6875 6.99994C12.6875 7.32211 12.4263 7.58327 12.1042 7.58327H2.1875V6.41661H12.1042Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrowShortail;
